import { render, staticRenderFns } from "./DefaultDataFormEditCompany.vue?vue&type=template&id=6f24f0ab&"
import script from "./DefaultDataFormEditCompany.vue?vue&type=script&lang=js&"
export * from "./DefaultDataFormEditCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports